<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <!-- <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider> -->
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item
        label="上级部门"
        prop="parentId"
      >
        <a-tree-select
          v-model="form.parentId"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="deptOptions"
          placeholder="请选择"
          :replaceFields="{ children: 'children', title: 'deptName', key: 'id', value: 'id' }"
          tree-default-expand-all
          :disabled="form.id ? true : false"
          allowClear
        >
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item
        label="类型"
        prop="type"
      >
        <a-radio-group
          v-model="form.type"
          button-style="solid"
          @change="handleChange"
          :disabled="form.id ? true : false"
        >
          <a-radio-button :value="0">公司</a-radio-button>
          <a-radio-button :value="1">部门</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        label="部门名称"
        prop="deptName"
        v-if="form.type"
      >
        <a-input
          v-model="form.deptName"
          placeholder="请输入"
          @change="handleChangeName"
        />
      </a-form-model-item>
      <a-form-model-item
        label="公司名称"
        prop="deptNames"
        v-if="form.type == 0"
      >
        <a-input
          v-model="form.deptNames"
          placeholder="请输入"
        />
      </a-form-model-item>
      <a-form-model-item
        label="负责人"
        prop="leader"
      >
        <a-input
          v-model="form.leader"
          placeholder="请输入"
        />
      </a-form-model-item>
      <a-form-model-item
        label="联系电话"
        prop="phone"
      >
        <a-input
          v-model="form.phone"
          placeholder="请输入"
          :maxLength="11"
          oninput="value=value.replace(/[^\d]/g,'')"
        />
      </a-form-model-item>

      <!-- <a-form-model-item
        label="公司名称"
        prop="name"
        v-if="form.type == 0"
      >
        <a-input
          v-model="form.name"
          placeholder="请输入"
        />
      </a-form-model-item> -->
      <a-form-model-item
        label="公司类型"
        prop="types"
        v-if="form.type == 0"
      >
        <a-select
          placeholder="请选择"
          v-model="form.types"
          style="width: 100%"
          allow-clear
        >
          <a-select-option
            :key="index"
            v-for="(item, index) in listDate"
            :value="item.id"
          >{{ item.dictLabel }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- <a-form-model-item
        label="公司负责人名"
        prop="contactsName"
        v-if="form.type == 0"
      >
        <a-input
          v-model="form.contactsName"
          placeholder="请输入"
          :maxLength="30"
        />
      </a-form-model-item>
      <a-form-model-item
        label="联系电话"
        prop="contactsPhone"
        v-if="form.type == 0"
      >
        <a-input
          v-model="form.contactsPhone"
          placeholder="请输入"
          :maxLength="11"
          oninput="value=value.replace(/[^\d]/g,'')"
        />
      </a-form-model-item> -->
      <a-form-model-item
        label="商户号账号"
        prop="subMchidLoginUserName"
        v-if="form.type == 0"
      >
        <a-input
          v-model="form.subMchidLoginUserName"
          placeholder="请输入"
          :maxLength="30"
        />
      </a-form-model-item>
      <a-form-model-item
        label="商户号密码"
        prop="subMchidLoginPassword"
        v-if="form.type == 0"
      >
        <a-input
          v-model="form.subMchidLoginPassword"
          placeholder="请输入"
          :maxLength="30"
        />
      </a-form-model-item>
      <a-form-model-item
        label="商户号"
        prop="subMchid"
        v-if="form.type == 0"
      >
        <a-input
          v-model="form.subMchid"
          placeholder="请输入"
          :maxLength="30"
        />
      </a-form-model-item>
      <a-form-model-item
        label="商户APPID"
        prop="subAppid"
        v-if="form.type == 0"
      >
        <a-input
          v-model="form.subAppid"
          placeholder="请输入"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item
        label="收款账号"
        prop="receivingAccount"
        v-if="form.type == 0"
      >
        <a-input
          v-model="form.receivingAccount"
          placeholder="请输入"
          :maxLength="30"
        />
      </a-form-model-item>
      <a-form-model-item
        label="排序"
        prop="orderNum"
      >
        <a-input-number
          v-model="form.orderNum"
          :min="0"
          style="width: 100%"
        />
      </a-form-model-item>

      <a-form-model-item
        label="邮箱"
        prop="email"
      >
        <a-input
          v-model="form.email"
          placeholder="请输入"
        />
      </a-form-model-item>
      <a-form-model-item
        label="状态"
        prop="status"
      >
        <a-radio-group
          v-model="form.status"
          button-style="solid"
        >
          <a-radio-button
            v-for="(d, index) in statusOptions"
            :key="index"
            :value="parseInt(d.value)"
          >{{ d.label }}</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button
            type="primary"
            :loading="submitLoading"
            @click="submitForm"
          >
            {{ $t('保存') }}
          </a-button>
          <a-button
            type="dashed"
            @click="cancel"
          >
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { getDept, addDept, updateDept, listType } from '@/api/system/dept'
import { unDoIcon } from 'amis-ui'

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true
    },
    deptOptions: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        parentId: undefined,
        deptName: undefined,
        orderNum: 0,
        deptNames: undefined,
        leader: undefined,
        phone: undefined,
        email: undefined,
        status: 1,
        type: 0,
        name: undefined,
        contactsName: undefined,
        contactsPhone: undefined,
        subMchidLoginUserName: undefined,
        subMchidLoginPassword: undefined,
        subMchid: undefined,
        subAppid: undefined,
        receivingAccount: undefined
      },
      open: false,
      typeOptions: [],
      listDate: [],
      depID: '',
      rules: {
        // parentId: [{ required: true, message: '上级部门不能为空', trigger: 'change' }],
        deptName: [{ required: true, message: `部门名称不能为空`, trigger: 'blur' }],
        deptNames: [{ required: true, message: `公司名称不能为空`, trigger: 'blur' }],
        orderNum: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        contactsName: [{ required: true, message: '请输入公司负责人名', trigger: 'blur' }],
        receivingAccount: [{ required: true, message: '请输入收款账号', trigger: 'blur' }],
        contactsPhone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }, {
          pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          message: '请输入正确的手机号码',
          trigger: 'blur'
        }],
        leader: [{ required: true, message: '请输入负责人名称', trigger: 'blur' }],
        types: [{ required: true, message: '公司类型不能为空', trigger: 'blur' }],
        subMchidLoginUserName: [{ required: true, message: '请输入商户号账号', trigger: 'blur' }],
        subMchidLoginPassword: [{ required: true, message: '请输入商户号密码', trigger: 'blur' }],
        subMchid: [{ required: true, message: '请输入商户号', trigger: 'blur' }],
        subAppid: [{ required: true, message: '请输入商户APPID', trigger: 'blur' }],
        email: [
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    listType({ pageSize: 9999, pageNum: 1 }).then(res => {
      console.log(res, 'ddd嘟嘟嘟嘟');
      this.listDate = res.data
    })
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    handleChangeName (e) {

      this.form.deptNames = this.form.deptName
    },
    // 表单重置
    reset () {
      this.form = {
        id: undefined,
        parentId: undefined,
        deptName: undefined,
        orderNum: 0,
        leader: undefined,
        phone: undefined,
        email: undefined,
        deptNames: undefined,
        status: 1,
        type: 0,
        name: undefined,
        contactsName: undefined,
        contactsPhone: undefined,
        subMchidLoginUserName: undefined,
        subMchidLoginPassword: undefined,
        subMchid: undefined,
        subAppid: undefined,
        receivingAccount: undefined
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      console.log('row', row)
      this.reset()
      if (row !== undefined) {
        this.form.parentId = row.id
      }
      this.open = true
      this.formTitle = '添加部门'
      this.$emit('select-tree')
    },
    handleChange () {
      if (this.form.deptName) {
        this.form.deptNames = this.form.deptName
      }
      if (this.form.deptNames) {
        this.form.deptName = this.form.deptNames
      }
    },
    /** 修改按钮操作 */
    handleUpdate (row) {
      this.reset()
      const deptId = row.id
      getDept(deptId).then(response => {
        let res = response.data
        console.log(res, 'dddd');
        if (res.parentId == 0) {
          res.parentId = '顶级'
        }
        res.deptNames = res.deptName
        if (res.type == 0 && res.companyAddParam) {
          // res.name = res.companyAddParam.name
          // res.contactsName = res.companyAddParam.contactsName
          // res.contactsPhone = res.companyAddParam.contactsPhone
          res.subMchidLoginUserName = res.companyAddParam.subMchidLoginUserName
          res.sort = res.companyAddParam.sort
          res.subMchidLoginPassword = res.companyAddParam.subMchidLoginPassword
          res.subMchid = res.companyAddParam.subMchid
          res.subAppid = res.companyAddParam.subAppid
          res.types = res.companyAddParam.type
          res.receivingAccount = res.companyAddParam.receivingAccount
          this.depID = res.companyAddParam.id
          console.log(this.depID, '嘟嘟嘟嘟');
        }
        this.form = res
        this.open = true
        this.formTitle = '修改部门'
      })
      this.$emit('select-tree', row)
    },
    /** 提交按钮 */
    submitForm: function () {
      let that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.deptNames) {
            this.form.deptName = this.form.deptNames
          }
          this.submitLoading = true
          let form = JSON.parse(JSON.stringify(this.form))
          form.companyAddParam = {

          }
          if (this.form.type == 0) {
            form.companyAddParam.name = form.deptName
            form.companyAddParam.sort = form.orderNum
            form.companyAddParam.contactsName = form.leader
            form.companyAddParam.contactsPhone = form.phone
            form.companyAddParam.subMchidLoginUserName = form.subMchidLoginUserName
            form.companyAddParam.subMchidLoginPassword = form.subMchidLoginPassword
            form.companyAddParam.subMchid = form.subMchid
            form.companyAddParam.subAppid = form.subAppid
            form.companyAddParam.type = form.types
            form.companyAddParam.receivingAccount = form.receivingAccount
          }
          if (this.form.id !== undefined) {
            form.companyAddParam.id = that.depID
            form.companyEditParam = form.companyAddParam
            form.parentId == '顶级'
            form.parentId = 0

            updateDept(form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              console.log();
              this.submitLoading = false
            })
          } else {
            addDept(form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
